/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Chkk API v1.0
 * Chkk API for Kubernetes deployment and upgrade safety.
 * OpenAPI spec version: v1.0
 */

/**
 * The status of the LAR's ignore state
 */
export type LARIgnoreStatus =
  (typeof LARIgnoreStatus)[keyof typeof LARIgnoreStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LARIgnoreStatus = {
  ignored: 'ignored',
  unignored: 'unignored',
} as const;
